
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/industries",
      function () {
        return require("private-next-pages/solutions/industries.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/industries"])
      });
    }
  